import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Mandoob } from '../../mandoobs/mandoob.model';
import { MandoobService } from '../../mandoobs/mandoob.service';
import { Users } from '../users.model';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.css']
})
export class AdduserComponent implements OnInit {

  user: Users = {} as Users;
  updateMode = false;
  active = true;
  spinnerOverlay = false;
  roles: { id: number, name: string }[] = [];
  selectedRole: number = 1;
  selectedMandoob!: number;
  mandoobs: Mandoob[] = [];
  addNew: boolean = false;
  // @Output() addNew = new EventEmitter<number>();

  constructor(private router: Router,
    private service: UsersService,
    private mandoobService: MandoobService,
    private translate: TranslateService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.roles = [
      { id: 2, name: this.translate.instant("assistant") },
      { id: 3, name: this.translate.instant("mandoob") }
    ];

    this.user.ballance = 0;

    this.selectedRole = 1;
  }

  getMandoobs() {
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data;
    }, error => {
      console.log(error);
    })
  }

  submit() {

    if (this.user.password != this.user.confirmPassword) {
      this.openSnackBar("password and confirmation do not match", 'snackBarError');
    }
    else {
      this.create();
    }
  }

  create() {
    this.spinnerOverlay = true;
    this.user.role = this.selectedRole;
    this.user.mandoobId = this.selectedMandoob;
    this.service.Create(this.user).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar("تم التخزين بنجاح", 'snackBarSuccess');
      this.user = {} as Users;
      //this.addNewItem(1);
      this.addNew = true;
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

  onRoleSelected() {
    if (this.selectedRole == 3) {
      this.getMandoobs();
    }
  }

  onSelectMandoob() {
    this.selectedRole == 3 ?
      this.user.fullName = this.mandoobs.find(x => x.id == this.selectedMandoob)!.name :
      this.user.fullName = "";
  }

  // addNewItem(value: number) {
  //   this.addNew.emit(value);
  // }
}
